module.exports = __webpack_public_path__ + "static/media/bannerHome.79329809.jpg";